import { Injectable } from '@angular/core';
import { ApiService, SolicitacaoFerias, StatusSolicitacao } from '../../api.service';

@Injectable({ providedIn: 'root' })
export class ServicoSolicitacaoAdministrativa {
  constructor(private readonly api: ApiService) {}

  resumo(empregadorId: string) {
    return this.api.resumoSolicitacoes(empregadorId);
  }

  listarAjustes(empregadorId: string, status?: StatusSolicitacao) {
    return this.api.listarAjustesGerencial(empregadorId, status);
  }

  decidirAjuste(id: string, deferida: boolean, parecer?: string) {
    return this.api.decidirAjusteGerencial(id, deferida, parecer);
  }

  listarFerias(empregadorId: string, status?: StatusSolicitacao) {
    return this.api.listarFeriasGerencial(empregadorId, status);
  }

  listarFeriasPeriodo(
    empregadorId: string,
    dataInicial: string,
    dataFinal: string,
    status?: StatusSolicitacao,
    pagina = 1,
    limite = 50
  ) {
    return this.api.listarFeriasListagem(empregadorId, dataInicial, dataFinal, status, pagina, limite);
  }

  editarFerias(item: SolicitacaoFerias) {
    return this.api.editarFeriasGerencial(item.id, {
      dataInicio: item.dataInicio,
      dataFim: item.dataFim,
      periodoAquisitivo: item.periodoAquisitivo,
      dataInicioPortaria: item.dataInicioPortaria || item.dataInicio,
      dataFimPortaria: item.dataFimPortaria || item.dataFim
    });
  }

  pedirFerias(funcionarioId: string, dataInicio: string, dataFim: string) {
    return this.api.pedirFeriasGerencial(funcionarioId, dataInicio, dataFim);
  }

  decidirFerias(
    id: string,
    deferida: boolean,
    parecer?: string,
    extra?: { secretariaId?: string; periodoAquisitivo?: string; dataInicio?: string; dataFim?: string }
  ) {
    return this.api.decidirFeriasGerencial(id, deferida, parecer, extra);
  }

  baixarPortaria(id: string) {
    return this.api.baixarPortariaFerias(id);
  }

  rotuloStatus(status?: StatusSolicitacao) {
    if (status === 'DEFERIDA') {
      return 'Deferida';
    }
    if (status === 'INDEFERIDA') {
      return 'Indeferida';
    }
    return 'Pendente';
  }
}
